var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _path0, _g3, _g4, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g5, _g6, _g7, _path16, _path17, _path18, _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtDashboardMagnifyingGlass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 3.19 4.09 2.395 2.375-2.417L1.055 0 0 3.19z",
    id: "34i2qiktza"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.89 7.728c-1.001 3.137-4.414 4.885-7.62 3.905-3.206-.98-4.993-4.318-3.992-7.455C1.28 1.04 4.692-.708 7.898.272c3.207.98 4.994 4.319 3.992 7.456z",
    id: "jt5e3jk64c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.846 18.29c-4.919 2.193-10.722.07-12.963-4.742C-1.357 8.735.813 3.057 5.731.864c4.92-2.192 10.722-.07 12.963 4.744 2.241 4.812.07 10.49-4.848 12.683z",
    id: "vthw7eswwe"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#89CFE5",
    fillRule: "nonzero",
    d: "M20.768 50.605 36.696 7.153 68 18.138 52.072 61.589z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m17.864 3.475 28.886 8.832-14.102 41.715C15.905-1.273 17.455 4.588 17.864 3.475z",
    fill: "#D9F4FF",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(17.613 7.017)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCF5FF",
    fillRule: "nonzero",
    d: "m17.613 54.163 14.07-44.062 31.744 9.703-14.07 44.063z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.208 15.805c-.349-.608.939-.064-10.18-3.462l-3.984 12.473 12.833 3.924 3.366-10.54a8.567 8.567 0 0 1-2.037-2.395h.002z",
    fill: "#9CD9F2",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.095 13.994c-.117.193-.242.047.956.747l2.35-3.45-.015-1.225c.556-.241 1.945.558 1.991 1.166l-1.11.567-1.997 3.657c1.21.708 1.011.656 1.125.471l-.906-.531 1.9-3.476c1.271-.65 1.142-.569 1.152-.625.112-.71-1.7-1.771-2.287-1.34-.048.036-.035-.115-.019 1.29L39 14.525l-.906-.53h.001z",
    fill: "#B59F69",
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37.463 13.965 4.09 2.395 2.374-2.417c-4.897-2.868-2.252-1.32-5.41-3.168l-1.054 3.19z",
    fill: "#2A292B",
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.463 10.775)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t4a7uo5jib",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#34i2qiktza"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#t4a7uo5jib)",
    fill: "#444",
    fillRule: "nonzero",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.996 1.372a.835.835 0 0 1 1.145.211L9.207 3.11c.257.368.16.87-.217 1.12L4.2 7.428a.835.835 0 0 1-1.146-.211L1.99 5.688a.795.795 0 0 1 .216-1.12L6.998 1.37l-.002.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.826-.6a.835.835 0 0 1 1.145.21l1.064 1.528c.257.367.16.869-.216 1.12L2.026 5.455a.835.835 0 0 1-1.145-.212L-.183 3.716a.795.795 0 0 1 .216-1.12L4.825-.601h.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.362-.622a.835.835 0 0 1 1.145.212L6.57 1.116c.257.368.16.87-.216 1.12L1.563 5.434a.835.835 0 0 1-1.145-.211L-.647 3.695a.795.795 0 0 1 .216-1.12L4.36-.622h.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25-1.608a.835.835 0 0 1 1.145.212L4.459.131c.257.367.16.869-.216 1.12L-.55 4.448a.835.835 0 0 1-1.145-.212l-1.065-1.528a.795.795 0 0 1 .216-1.12L2.25-1.61v.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82-1.074a.835.835 0 0 1 1.145.212L5.031.665c.255.367.16.869-.216 1.12L.022 4.982a.835.835 0 0 1-1.145-.212l-1.064-1.528a.796.796 0 0 1 .216-1.12L2.82-1.075v.001z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.929 13.943c-6.23-3.648-5.524-3.116-5.124-3.302 5.813 3.404 5.05 2.836 5.124 3.302zM37.328 13.884c.097-.16-.108-.216 4.29 2.36.125.072.042.182.05.182-.098.159.107.215-4.291-2.36-.09-.053-.071-.182-.05-.182z",
    fill: "#0C0C0C",
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.011 13.945c-.119.193-.242.047.957.747l2.35-3.45-.015-1.224c.582-.253 1.95.586 1.993 1.166l-1.11.567-1.998 3.656c1.21.709 1.012.655 1.125.472l-.905-.53 1.898-3.476c1.273-.65 1.144-.568 1.153-.627.11-.711-1.697-1.77-2.288-1.339-.048.036-.035-.116-.019 1.288l-2.235 3.28-.906-.53z",
    fill: "#FFCB39",
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A5238",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.38 23.57 1.287-4.031 1.236.377-1.288 4.032zM42.121 25.937l1.287-4.031 1.236.377-1.287 4.032zM35.94 24.046l1.977-6.192 1.236.378-1.977 6.192zM40.56 25.458l1.978-6.192 1.235.378-1.977 6.192zM37.493 24.522l1.6-5.012 1.236.378-1.6 5.012zM39.023 24.989l.543-1.7 1.236.378-.543 1.7z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A5238",
    fillRule: "nonzero",
    d: "m34.44 24.545.312-.976 8.755 2.677-.312.976z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#77C7E0",
    fillRule: "nonzero",
    d: "m45.977 15.383 2.279 2.78-2.777-.21zM39.236 36.593c-1.001 3.137-4.414 4.885-7.62 3.905-3.206-.98-4.993-4.318-3.992-7.455 1.002-3.137 4.414-4.886 7.62-3.906 3.207.98 4.994 4.319 3.992 7.456z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.346 28.865)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fkqfocpfcd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jt5e3jk64c"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#fkqfocpfcd)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.157-.022 6.084 5.953l5.818-2.56c.492-.215.97.339-3.745-3.415z",
    fill: "#8BDEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.084 5.953 5.818-2.56s.964 1.277.775 3.02l-6.593-.462v.002z",
    fill: "#228191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.084 5.953 2.65 6.521s4.35-2.624 3.583-6.085l-6.234-.436h.001z",
    fill: "#85F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-.803 6.972 6.889-1.02 2.324 5.72s-6.452 3.246-9.213-4.7z",
    fill: "#5BAEC1"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#77C7E0",
    d: "m42.523 33.985.57-1.785 1.825.557-.57 1.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8BDEF2",
    d: "m41.843 36.113.57-1.785 1.825.558-.57 1.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#228191",
    d: "m41.134 38.33.57-1.785 1.825.558-.57 1.785z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85F4FF",
    d: "m40.434 40.519.57-1.785 1.825.557-.57 1.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5BAEC1",
    d: "m39.727 42.737.57-1.785 1.824.558-.57 1.785z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.148 42.805c3.238-10.14 2.984-9.106 2.76-9.174l-2.966 9.287 7.881 2.41c.075-.231.91.102-7.675-2.522v-.001z",
    fill: "#5BAEC1",
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m46.513 40.14.483.972 3.04-3.073.597 1.014c3.767-3.59 3.76-3.458-.02.146l-.597-1.011-3.045 3.08-.49-.986c-3.493 2.7-3.8 2.824.033-.14l-.001-.002z",
    fill: "#5BAEC1",
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m47.405 37.877.936 3.502 3.61-4.621.359 1.477 1.36-1.423c.097.088.277-.158-1.411 1.607l-.353-1.455-3.605 4.616-.94-3.52c-5.289 5.625-4.51 4.662.046-.183h-.002z",
    fill: "#5BAEC1",
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.694 42.69c-.032-.128-.325-.015 2.705-.75l.135.758 1.328-.85c-.245.768-.762.93 2.781-1.422l-.052.704 1.852-.982c.064.115.266-.039-1.956 1.14l.05-.683-3.013 2 .174-.543-1.229.787-.142-.797-2.632.639-.001-.001z",
    fill: "#5BAEC1",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.163 38.472c-.207.645-1.193.341-.99-.305.206-.65 1.192-.341.99.305zM50.857 38.632c-.203.646-1.193.342-.99-.304.206-.65 1.192-.342.99.304zM52.744 37.33c-.203.647-1.194.342-.99-.305.206-.647 1.192-.342.99.305z",
    fill: "#2E7682",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.47 39.546c-.207.648-1.196.34-.99-.304.208-.649 1.196-.341.99.304zM47.257 40.666c-.206.647-1.193.342-.99-.305.206-.647 1.193-.342.99.305zM49.15 41.958c-.206.65-1.193.342-.99-.304.202-.646 1.193-.342.99.304zM47.218 42.443c-.206.648-1.193.34-.99-.304.202-.649 1.193-.341.99.304z",
    fill: "#2E7682",
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.622 42.35c-.207.65-1.194.342-.991-.304.203-.646 1.193-.342.99.304zM51.439 40.96c-.203.646-1.193.341-.99-.305.206-.65 1.193-.341.99.305z",
    fill: "#2E7682",
    fillRule: "nonzero"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A5238",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.386 21.152c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413zM60.187 21.772c-11.25-3.44-10.17-2.953-10.024-3.412 11.25 3.44 10.17 2.954 10.024 3.412z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.949 22.52c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.412zM59.752 23.14c-11.25-3.44-10.171-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.489 23.96c-11.25-3.439-10.17-2.953-10.024-3.412 11.25 3.44 10.17 2.954 10.024 3.413zM59.291 24.58c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.171 2.954 10.024 3.413z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.052 25.327c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413zM58.855 25.948c-11.25-3.44-10.171-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.58 26.804c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413zM58.383 27.425c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.143 28.172c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413zM57.946 28.792c-11.25-3.44-10.17-2.954-10.024-3.412 11.25 3.44 10.17 2.953 10.024 3.412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.683 29.613c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413zM57.486 30.232c-11.25-3.44-10.17-2.954-10.024-3.412 11.25 3.44 10.17 2.953 10.024 3.412z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.248 30.98c-11.25-3.44-10.17-2.955-10.024-3.413 11.25 3.44 10.17 2.953 10.024 3.412zM57.049 31.6c-11.25-3.44-10.17-2.954-10.024-3.413 11.25 3.44 10.17 2.954 10.024 3.413z"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#9A5238",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.524 43.722.311-.976 11.2 3.423-.311.976zM36.944 47.212l.312-.976 2.253.689-.312.976zM39.498 47.993l.312-.976 10.942 3.345-.312.976zM25.185 44.786l.312-.976 1.663.508-.311.976zM24.854 45.824l.312-.976 4.853 1.484-.312.976zM30.034 47.408l.311-.976 1.134.347-.312.976zM31.476 47.848l.311-.976 5.049 1.543-.312.976zM36.733 49.51l.312-.975.997.305-.312.976zM37.884 49.863l.312-.976.997.305-.311.976zM39.054 50.166l.312-.976 4.946 1.512-.312.976zM44.382 51.794l.312-.976 5.387 1.647-.312.976zM27.134 45.384l.311-.976 5.807 1.775-.312.976zM33.334 47.279l.312-.976 9.349 2.858-.312.976zM42.989 50.23l.311-.976 7.112 2.174-.312.976z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.54 46.835.312-.976 11.2 3.423-.312.976zM35.96 50.326l.312-.976 2.253.69-.312.975zM38.514 51.107l.312-.976 10.942 3.345-.312.976zM24.2 47.901l.313-.976 1.663.509-.311.976zM23.87 48.937l.312-.976 4.853 1.483-.311.976zM29.05 50.52l.312-.976 1.133.346-.311.976zM30.492 50.96l.312-.975 5.048 1.543-.311.976zM35.754 52.63l.312-.976.997.305-.312.976zM36.902 52.98l.312-.975.997.305-.312.976zM38.072 53.279l.312-.976 4.946 1.512-.312.976zM43.399 54.906l.311-.976 5.387 1.646-.312.976zM26.152 48.497l.311-.976 5.807 1.775-.312.976zM32.35 50.392l.312-.976 9.35 2.857-.312.976zM42.005 53.343l.311-.976 7.112 2.174-.312.976z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23.623 50.015.312-.976 11.2 3.423-.312.976zM35.045 53.514l.312-.976 2.252.69-.311.975zM37.596 54.287l.312-.976 10.942 3.345-.312.976zM23.281 51.08l.312-.975 1.664.508-.312.976zM22.952 52.117l.312-.976 4.853 1.483-.312.976zM28.132 53.698l.312-.976 1.133.347-.312.976zM29.574 54.14l.311-.975 5.049 1.543-.312.976zM34.834 55.809l.312-.976.997.305-.312.976zM35.983 56.16l.312-.976.997.305-.311.976zM37.154 56.459l.312-.976 4.946 1.512-.312.976zM42.48 58.089l.312-.976 5.387 1.646-.312.976zM25.232 51.676l.312-.976 5.806 1.775-.312.976zM31.432 53.572l.312-.976 9.349 2.857-.312.976zM41.085 56.524l.312-.976 7.111 2.174-.312.976z"
  })))), /*#__PURE__*/React.createElement("g", null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "m18.578 29.465 2.796-1.247 1.427 3.064-2.796 1.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m18.996 30.371 2.797-1.246.726 1.56-2.797 1.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m19.245 31.009 2.797-1.246.433.93-2.796 1.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m17.94 29.293.95-.424 1.861 3.994-.95.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.585 28.936c.71.387.302-.206 1.96 3.355l-.1.64-1.86-3.995zM17.924 29.23c-.167.78-.357.088 1.302 3.65l.559.344-1.86-3.994z",
    fill: "#F6C760"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "m18.71 30.587.951-.424 1.142 2.452-.95.424z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "m3 36.413 14.798-6.598 1.427 3.064-14.798 6.598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m3.42 37.316 14.799-6.599.726 1.56-14.798 6.598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AE18",
    d: "m3.65 37.96 14.798-6.599.434.93L4.083 38.89z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3.097 36.62 1.224 2.627s-1.643-1.139-1.224-2.627z",
    fill: "#F2AE18"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.368 21.638c-2.355-5.059-8.457-7.293-13.628-4.987-5.171 2.305-7.453 8.276-5.096 13.334 2.356 5.059 8.458 7.292 13.628 4.986 5.17-2.305 7.454-8.275 5.096-13.333zM22.21 29.732C19.997 24.98 22.14 19.371 27 17.207c4.858-2.166 10.59-.068 12.802 4.685 2.213 4.753.07 10.361-4.789 12.525-4.858 2.166-10.59.068-12.803-4.685h.001z",
    fill: "#F6C760",
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.96 21.82c-2.254-4.84-8.09-6.975-13.035-4.77s-7.128 7.915-4.874 12.753c2.254 4.839 8.089 6.975 13.034 4.77s7.128-7.915 4.874-12.754zm-17.366 7.74c-2.117-4.545-.067-9.908 4.579-11.98 4.646-2.07 10.127-.065 12.245 4.48 2.116 4.547.067 9.909-4.58 11.981-4.646 2.07-10.128.065-12.244-4.48z",
    fill: "#F2AE18",
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.98 34.324c-4.919 2.192-10.722.07-12.963-4.744-2.24-4.813-.07-10.49 4.848-12.683 4.92-2.193 10.722-.07 12.964 4.743 2.24 4.813.07 10.49-4.848 12.684z",
    fill: "#ADD3F2",
    fillRule: "nonzero",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.217 16.233)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "aegipm0nrf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vthw7eswwe"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#aegipm0nrf)",
    fill: "#ADD3F2",
    fillRule: "nonzero",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-83.74 14.626 6.738)",
    d: "m15.837-13.403 2.098.005.076 32.408-2.098-.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-83.74 14.186 11.803)",
    d: "m13.102-8.343 6.688.016.076 32.407-6.688-.016z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    transform: "rotate(-83.74 14.517 12.447)",
    d: "m15.964-7.693 1.626.004.076 32.407-1.626-.004z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtDashboardMagnifyingGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-dashboard-magnifying-glass.e2d4589c56a54399f216e453be65d4bb.svg";